/**
 * 🤖 AUTO-GENERATED API SCHEMA FILE - DO NOT EDIT DIRECTLY!
 *
 * This file is automatically generated from entity configuration files.
 * Any manual changes will be lost when the generator runs again.
 *
 * 🔄 DATA FLOW PIPELINE:
 * 1. Entity Config (config/entities/lookup_party_roles-entity-config.ts) → Single Source of Truth
 * 2. THIS FILE → TypeBox schemas for runtime validation + API types
 * 3. API Clients → Use these schemas for request/response validation
 * 4. React Hooks → Use these types for type-safe data fetching
 * 5. Components → Import types from this schema file
 *
 * 🛠️ TO MODIFY:
 * - Edit the entity config file: config/entities/lookup_party_roles-entity-config.ts
 * - Run: npm run schemas:gen (regenerates this file)
 *
 * 📋 ARCHITECTURE:
 * - Entity configs define field publicity, types, and validation rules
 * - TypeBox schemas provide runtime validation for API requests/responses
 * - Static types are derived from TypeBox schemas for compile-time safety
 * - Query options and response types standardize API interactions
 *
 * 🔗 RELATED FILES:
 * - config/entities/lookup_party_roles-entity-config.ts (source configuration)
 * - scripts/generate-api-clients.ts (this generator)
 * - client/api/generated_clients/generated-lookup_party_roles-api-client.ts (API client using these schemas)
 * - client/api/generated_hooks/lookup_party_roles.ts (React hooks using these types)
 *
 * 🔒 SECURITY: Only fields marked as 'public: true' in the config are included
 *
 * Source config: config/entities/lookup_party_roles-entity-config.ts
 * Public fields: 6/6 total fields
 */

import { Type, Static } from '@sinclair/typebox';


// TypeBox schemas for runtime validation (public fields only)
export const LookupPartyRolesSchema = Type.Object({
  id: Type.String({ format: "uuid" }), // id field
  name: Type.Union([Type.String(), Type.Null()]), // name field
  code: Type.Union([Type.String(), Type.Null()]), // code field
  description: Type.Union([Type.String(), Type.Null()]), // description field
  created_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // created_at field
  updated_at: Type.String({ format: "date-time" }), // updated_at field
});

export const CreateLookupPartyRolesSchema = Type.Object({
  name: Type.Optional(Type.Union([Type.String(), Type.Null()])), // name field
  code: Type.Optional(Type.Union([Type.String(), Type.Null()])), // code field
  description: Type.Optional(Type.Union([Type.String(), Type.Null()])), // description field
});

export const UpdateLookupPartyRolesSchema = Type.Object({
  name: Type.Optional(Type.Union([Type.String(), Type.Null()])), // name field
  code: Type.Optional(Type.Union([Type.String(), Type.Null()])), // code field
  description: Type.Optional(Type.Union([Type.String(), Type.Null()])), // description field
});

// TypeScript types derived from TypeBox schemas (matching server-side pattern)
export type LookupPartyRolesRow = Static<typeof LookupPartyRolesSchema>;
export type LookupPartyRolesInsert = Static<typeof CreateLookupPartyRolesSchema>;
export type LookupPartyRolesUpdate = Static<typeof UpdateLookupPartyRolesSchema>;

// Legacy type aliases for backward compatibility
export type LookupPartyRoles = LookupPartyRolesRow;
export type CreateLookupPartyRoles = LookupPartyRolesInsert;
export type UpdateLookupPartyRoles = Static<typeof UpdateLookupPartyRolesSchema>;

// Field configuration metadata
export const LookupPartyRolesFieldConfig = {
  filterable: ['id'] as const,
  sortable: ['created_at', 'updated_at'] as const,
  searchable: [] as const,
  required: ['id', 'updated_at'] as const,
  readonly: ['id', 'created_at', 'updated_at'] as const,
} as const;

// Query options interface for API operations
import type { UnifiedQueryOptions } from '../../config/search/global-search-config.js';

export interface LookupPartyRolesQueryOptions extends UnifiedQueryOptions {}

// Response types for API operations
export interface LookupPartyRolesResponse {
  data: LookupPartyRoles[] | null;
  error: Error | null;
  count?: number;
}

export interface SingleLookupPartyRolesResponse {
  data: LookupPartyRoles | null;
  error: Error | null;
}
